import { render, staticRenderFns } from "./GenreSelector.vue?vue&type=template&id=f2f8f676&scoped=true"
import script from "./GenreSelector.vue?vue&type=script&lang=js"
export * from "./GenreSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f8f676",
  null
  
)

export default component.exports